import Market, { MarketName } from '@/creditflowresearch/domain/Market';
import { parseQueryParamValue } from '@/creditflowresearch/ui/common/utils/query/parseQueryParams';

export const hasEmMarket = (query: Record<string, any>): boolean =>
  Market.hasAnyOfType(parseQueryParamValue(query.markets), MarketName.EMERGING_MARKET);
